import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'Audience Analysis',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  audienceAnalysisRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  compareAudienceAnalysisRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const audienceAnalysisSlice = createSlice({
  name: 'audienceAnalysis',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => ({ ...state, currentQuarter: action.payload }),
    setCurrentYear: (state, action) => ({ ...state, currentYear: action.payload }),
    setSelectedQuarter: (state, action) => ({ ...state, selectedQuarter: action.payload }),
    setSelectedYear: (state, action) => ({ ...state, selectedYear: action.payload }),
    setCompareSelectedYear: (state, action) => ({ ...state, compareSelectedYear: action.payload }),
    setCompareSelectedQuarter: (state, action) => ({
      ...state,
      compareSelectedQuarter: action.payload,
    }),
    setAudienceAnalysisRange: (state, action) => ({
      ...state,
      audienceAnalysisRange: action.payload,
    }),
    setCompareAudienceAnalysisRange: (state, action) => ({
      ...state,
      compareAudienceAnalysisRange: action.payload,
    }),
  },
});

export const audienceAnalysisActions = audienceAnalysisSlice.actions;

export default audienceAnalysisSlice.reducer;
